export function datetimeFormatter(datetime = "") {
  const date = new Date(datetime);

  return new Intl
    .DateTimeFormat(navigator.languages[0], { dateStyle: "short", timeStyle: "short" })
    .format(date);
}